// @ts-nocheck
import { ApiParameter, get, post } from "@insite/client-framework/Services/ApiService";
import {
    BomLeadTimeRequestModel,
    BomLeadTimeResponseModel,
    BomPricesRequestModel,
    BomPricesResponseModel,
    ConfigureRequestModel,
    ConfigureResponseModel,
    OptionsResponseModel,
    SelectorsResponseModel,
} from "@store/Framework/Types/ValveConfiguratorApiModels";

const baseUrl = "api/v1/valveconfigurator";

export interface GetValveOptionsApiParameter extends ApiParameter {
    series: string;
    size: number;
}

export function getValveSelectors(): Promise<SelectorsResponseModel> {
    return get<SelectorsResponseModel>(`${baseUrl}/selectors`);
}

export function getValveOptions(parameter: GetValveOptionsApiParameter): Promise<OptionsResponseModel> {
    return get<OptionsResponseModel>(`${baseUrl}/options`, parameter);
}

export function postValveConfigure(body: ConfigureRequestModel): Promise<ConfigureResponseModel> {
    return post<ConfigureRequestModel, ConfigureResponseModel>(`${baseUrl}/configure`, body);
}

export function postValveBomPrices(body: BomPricesRequestModel): Promise<BomPricesResponseModel> {
    return post<BomPricesRequestModel, BomPricesResponseModel>(`${baseUrl}/bomPrices`, body);
}

export function postValveBomLeadTime(body: BomLeadTimeRequestModel): Promise<BomLeadTimeResponseModel> {
    return post<BomLeadTimeRequestModel, BomLeadTimeResponseModel>(`${baseUrl}/bomLeadTime`, body);
}
